import { gql } from '@apollo/client'

import { useMutation } from 'hooks'

const FORM_SUBMISSION_CREATE_MUTATION = gql`
  mutation CreateSubmissionForm($formSubmission: FormSubmissionCreate) {
    formSubmissionCreate(formSubmission: $formSubmission) {
      id
      score
      answers {
        value {
          type
          bool
          number
          options {
            id
            value
          }
          notApplicable
        }
      }
      errors {
        message
      }
    }
  }
`

export const useFormSubmissionCreateMutation = opts =>
  useMutation(FORM_SUBMISSION_CREATE_MUTATION, opts)
